import "./widget_core.js"
var req = require.context('../../../public/javascripts/backbone/apps/tap2shop/', true, /\.js$/)
req.keys().forEach(req)
